import React from 'react';
import Header from "./components/Header"
import Intro from "./components/Intro"
import Divider from "./components/Divider"
import ProjectList from "./components/ProjectList"
import Footer from "./components/Footer"

const App = () =>
    <div className="App">
        <Header />
        <Intro />
        <Divider />
        <ProjectList />
        <Footer />
    </div>

export default App;
